import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { useFormContext, useWatch } from "react-hook-form";
import ReactJson from "@microlink/react-json-view";

function Apidata() {
  const { register } = useFormContext();
  const watchRawApiData = useWatch({ name: "rawApiData" });
  return (
    <Card style={{ maxWidth: 800 }}>
      <CardBody style={{ padding: 16 }}>
        <input {...register("rawApiData")} type={"hidden"} />
        {typeof watchRawApiData === "object" && watchRawApiData != null ? (
          <ReactJson collapsed={true} src={watchRawApiData} />
        ) : null}
      </CardBody>
    </Card>
  );
}

export default Apidata;
